import { render, staticRenderFns } from "./LaboratoryList.vue?vue&type=template&id=9a83954e&scoped=true"
import script from "./LaboratoryList.vue?vue&type=script&lang=js"
export * from "./LaboratoryList.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryList.vue?vue&type=style&index=0&id=9a83954e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a83954e",
  null
  
)

export default component.exports